module.exports = __webpack_public_path__ + "static/oskrds-9dff4a85d9c85e5eeb00b1a23f08da45.jpg";